module.exports = __webpack_public_path__ + "static/media/s5.1e7a6cd2.png";